import { SignalLevel } from "../docTypes/signal";
import { SignalSubjectDocType } from "../docTypes/signalSubjectDocType";
import { SignalSourceMeta } from "./signalSourceTypes";
import { signalSubjectRegistry } from "./signalSubjectRegistry";

export type SignalTypeMeta = {
  subjectDocType: SignalSubjectDocType;
  level: SignalLevel;
  actionLabel: string;
};

export const signalTypeMeta = {
  regionCustomer: {
    subjectDocType: "customer",
    level: "info",
    actionLabel: "Nowy klient w regionie",
  },
  regionCustomerMissingPhone: {
    subjectDocType: "customer",
    level: "warning",
    actionLabel: "Brak numeru telefonu",
  },
  regionCustomerMissingEmail: {
    subjectDocType: "customer",
    level: "warning",
    actionLabel: "Brak adresu e-mail",
  },
  posCustomerMissingGooglePlaceId: {
    subjectDocType: "customer",
    level: "warning",
    actionLabel: "Brak Google Place ID (POS)",
  },
  crmInteractionMention: {
    subjectDocType: "customer",
    level: "info",
    actionLabel: "Oznaczenie w interakcji w CRM",
  },
  crmOrderSuspended: {
    subjectDocType: "customer",
    level: "warning",
    actionLabel: "Zamówienie wstrzymane",
  },
  unreadInvoice: {
    subjectDocType: "invoice-thread",
    level: "warning",
    actionLabel: "Nieprzeczytana faktura",
  },
  
  invoiceThreadMention: {
    subjectDocType: "invoice-thread",
    level: "info",
    actionLabel: "Oznaczenie w komentarzu wątku faktury",
  },
  draftInvoice: {
    subjectDocType: "invoice-draft",
    level: "info",
    actionLabel: "Wersja robocza do dokończenia",
  },
  unreadTicket: {
    subjectDocType: "support-ticket",
    level: "warning",
    actionLabel: "Nowy e-mail w zgłoszeniu",
  },
  supportTicketMention: {
    subjectDocType: "support-ticket",
    level: "info",
    actionLabel: "Oznaczenie w notatce zgłoszenia",
  },
  loyaltyAdminOrderCreated: {
    subjectDocType: "fulfillment-order",
    level: "info",
    actionLabel: "Złożone zamówienie",
  },
} as const satisfies Record<string, SignalTypeMeta>;

export type SignalType = keyof typeof signalTypeMeta;

export const signalTypes = Object.keys(signalTypeMeta) as SignalType[];

export const isSignalType = (value: string): value is SignalType => value in signalTypeMeta;

export const navBadgeTypes = (...types: SignalType[]): readonly SignalType[] => types;

export const signalSourceMeta = (signalType: SignalType): SignalSourceMeta => ({
  signalType,
  subjectDocType: signalTypeMeta[signalType].subjectDocType,
  app: signalSubjectRegistry[signalTypeMeta[signalType].subjectDocType].app,
  level: signalTypeMeta[signalType].level,
});

export const subjectDocTypeForSignalType = (signalType: string): SignalSubjectDocType | null =>
  isSignalType(signalType) ? signalTypeMeta[signalType].subjectDocType : null;

export const signalTypeActionLabel = (signalType: SignalType): string => signalTypeMeta[signalType].actionLabel;
